module.exports = __webpack_public_path__ + "img/solution-pc-10.aa44d036.png";